import { computed, ref, useRoute } from '@nuxtjs/composition-api'
import BaseDropdown from 'primevue/dropdown'

import { getIcon } from '~/utils/get-icon.js'
import {
  DEFAULT_PAGE_SIZE,
  AVAILABLE_PAGING_SIZES,
  generatePagingItems,
} from '~/utils/paging'


export default {
  __name: 'whisky-catalogue-paging',
  props: {
  showPaging: {
    type: Boolean,
    default: true,
  },
  pageCount: {
    required: true,
    type: Number,
  },
  // 1-based "index"
  pageIndex: {
    default: 1,
    type: Number,
  },
  pageSize: {
    default: DEFAULT_PAGE_SIZE,
    type: [Number, String],
    validator: (value) => AVAILABLE_PAGING_SIZES.includes(parseInt(`${value}`)),
  },
},
  setup(__props) {

const props = __props;

const route = useRoute()



const _pageSize = ref(parseInt(`${props.pageSize}`))

const hasPrev = computed(() => {
  return props.pageIndex > 1
})

const hasNext = computed(() => {
  return props.pageIndex < props.pageCount
})

const pageNumbers = computed(() =>
  generatePagingItems(props.pageIndex, props.pageCount),
)

const getIconComponent = (name) => getIcon(name)

const getPageIndex = (pageNumber) => (pageNumber > 1 ? pageNumber : undefined)

return { __sfc: true,route, props, _pageSize, hasPrev, hasNext, pageNumbers, getIconComponent, getPageIndex, BaseDropdown, AVAILABLE_PAGING_SIZES }
}

}